import React, {useState, useEffect} from 'react';
import {Transforms} from 'slate';
import {useSlateStatic, ReactEditor} from 'slate-react';

export const ResizeContext = React.createContext<{
  width?: number;
  height?: number;
  crop?: any;
}>({});

export const ResizableElement = ({
  element,
  children,
  disabled = false
}: any): React.JSX.Element => {
  const editor = useSlateStatic();
  const [isResizing, setIsResizing] = useState(false);
  const [localSize, setLocalSize] = useState<{
    width: number;
    height: number;
  } | null>(null);

  const onMouseDown = (e: React.MouseEvent): void => {
    e.preventDefault();
    e.stopPropagation();
    setIsResizing(true);
    const startX = e.clientX;
    const startY = e.clientY;
    const startWidth = element.width || 200;
    const startHeight = element.height || 150;
    const initialRatio = startWidth / startHeight;

    const onMouseMove = (moveEvent: MouseEvent): void => {
      const diffX = moveEvent.clientX - startX;
      let newWidth = Math.max(50, startWidth + diffX);
      const newHeight = moveEvent.shiftKey
        ? Math.max(50, newWidth / initialRatio)
        : Math.max(50, startHeight + (moveEvent.clientY - startY));
      if (moveEvent.shiftKey && newHeight === 50) newWidth = 50 * initialRatio;
      setLocalSize({width: newWidth, height: newHeight});
    };

    const onMouseUp = (): void => {
      setIsResizing(false);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  useEffect(() => {
    if (!isResizing && localSize) {
      const path = ReactEditor.findPath(editor as any, element);
      Transforms.setNodes(
        editor,
        {width: localSize.width, height: localSize.height} as any,
        {at: path}
      );
      setLocalSize(null);
    }
  }, [isResizing, editor, element]);

  const currentWidth = (localSize?.width ?? element.width) || 'auto';
  const currentHeight = (localSize?.height ?? element.height) || 'auto';

  return (
    <ResizeContext.Provider
      value={{width: localSize?.width, height: localSize?.height}}
    >
      <div
        className="resizable-element-container"
        style={{
          position: 'relative',
          display: 'inline-block',
          width: currentWidth,
          height: currentHeight
        }}
      >
        {children}
        {!disabled && (
          <div
            className={`resize-handle ${isResizing ? 'resizing' : ''}`}
            onMouseDown={onMouseDown}
            style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: 12,
              height: 12,
              backgroundColor: '#1a73e8',
              borderRadius: '0 0 4px 0',
              cursor: 'nwse-resize',
              zIndex: 10
            }}
          ></div>
        )}
      </div>
    </ResizeContext.Provider>
  );
};
